import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Partners.css';
import part1 from "../images/partners/part1.jpeg"
import part2 from "../images/partners/part2.jpeg"
import part3 from "../images/partners/part3.jpeg"
import part4 from "../images/partners/part4.jpeg"
import part5 from "../images/partners/part5.jpeg"
import part6 from "../images/partners/part6.jpeg"
import part7 from "../images/partners/part7.jpeg"
import part8 from "../images/partners/part8.jpeg"
import part9 from "../images/partners/part9.jpeg"

const Partners = () => {
  const { t } = useLanguage();

  const images = [
    part1,
    part2,
    part3,
    part4,
    part5,
    part6,
    part7,
    part8,
    part9];


  return (
    <>
      <div style={{ clear: 'both' }} />
      <div className="partners-section" id="section-6">
        <div className="partners-wrap row">
          <div className="partners-title">
            <h4>{t.partners.title}</h4>
            <p>{t.partners.subtitle}</p>
          </div>

          <div className="partners-grid">
            {t.partners.items.map((partner, index) => (
              <div key={index} className="partner-card">
                <div className="partner-image">
                  <img src={images[index]} alt={partner.title} />
                  <div className="partner-overlay">
                    <div className="partner-social">
                      <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook" /></a>
                      <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter" /></a>
                      <a href="https://plus.google.com" target="_blank" rel="noopener noreferrer"><i className="fa fa-google-plus" /></a>
                      <a href="mailto:info@example.com"><i className="fa fa-envelope" /></a>
                    </div>
                  </div>
                </div>
                <div className="partner-info">
                  <h6 className="partner-name">{partner.title}</h6>
                  <p className="partner-desc">{partner.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Partners;
